import React from "react";
import styled from "styled-components";
import { HeaderMenuInjector } from "./HeaderMenuInjector";
import { Container, Segment } from "semantic-ui-react";
import { Main } from "./Main";
import { Footer } from "./Footer";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

function PageLayout({ children }) {
  return (
    <Wrapper>
      <HeaderMenuInjector>
        <Main>{children}</Main>
        <Footer>
          <Segment fixed="bottom">
            <Container>© Clarity Solutions, LLC</Container>
          </Segment>
        </Footer>
      </HeaderMenuInjector>
    </Wrapper>
  );
}

export default PageLayout;
